import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { User } from '../models';
import { UserEntityService } from './user-entity.service';

@Injectable({ providedIn: 'root' })
export class BasicUsersInfo implements Resolve<User[]> {
  constructor(private userEntityService: UserEntityService) {}
  resolve() {
    return this.userEntityService.getBasicUsersInfo();
  }
}
